import { createSlice } from '@reduxjs/toolkit'

const initialState: any = {
    isLoading: false,
    error: "",
    success: "",
    data: [],
};

export const reportRedux = createSlice({
    name: 'reportRedux',
    initialState,
    reducers: {
        // Report Post 
        reportPostRequest: (state, action) => {
            state.isLoading = true;
        },
        reportPostSuccess: (state, action) => {
            state.isLoading = false;
            state.success = true;
        },
        reportPostFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        //Report Project
        reportProjectRequest: (state, action) => {
            state.isLoading = true;
        },
        reportProjectSuccess: (state, action) => {
            state.isLoading = false;
            state.success = true;
        },
        reportProjectFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        //Report User
        reportUserRequest: (state, action) => {
            state.isLoading = true;
        },
        reportUserSuccess: (state, action) => {
            state.isLoading = false;
            state.success = true;
        },
        reportUserFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        //Report problem
        reportProblemRequest: (state, action) => {
            state.isLoading = true;
        },
        reportProblemSuccess: (state, action) => {
            state.isLoading = false;
            state.success = true;
        },
        reportProblemFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        //Report comment
        reportCommentRequest: (state, action) => {
            state.isLoading = true;
        },
        reportCommentSuccess: (state, action) => {
            state.isLoading = false;
            state.success = true;
        },
        reportCommentFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        //Report reply
        reportReplyRequest: (state, action) => {
            state.isLoading = true;
        },
        reportReplySuccess: (state, action) => {
            state.isLoading = false;
            state.success = true;
        },
        reportReplyFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        //Report collaborator
        reportCollaboratorRequest: (state, action) => {
            state.isLoading = true;
        },
        reportCollaboratorSuccess: (state, action) => {
            state.isLoading = false;
            state.success = true;
        },
        reportCollaboratorFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
})

export const {
    reportPostRequest,
    reportPostSuccess,
    reportPostFailure,

    reportProjectRequest,
    reportProjectSuccess,
    reportProjectFailure,

    reportUserRequest,
    reportUserSuccess,
    reportUserFailure,

    reportProblemRequest,
    reportProblemSuccess,
    reportProblemFailure,

    reportCommentRequest,
    reportCommentSuccess,
    reportCommentFailure,

    reportReplyRequest,
    reportReplySuccess,
    reportReplyFailure,

    reportCollaboratorRequest,
    reportCollaboratorSuccess,
    reportCollaboratorFailure


} = reportRedux.actions;

export default reportRedux.reducer;
